class SearchSortForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.select = this.querySelector('select[name="sort_by"]');

    if (this.select) {
      this.select.addEventListener('change', this.onSortChange.bind(this));
    }

    if (!SearchSortForm.listenersReady) {
      window.addEventListener('popstate', SearchSortForm.onPopState);
      SearchSortForm.searchParamsPrev = window.location.search.slice(1);
      SearchSortForm.listenersReady = true;
    }
  }

  onSortChange(event) {
    event.preventDefault();
    if (!event.isTrusted || !this.select || !this.form) return;

    const searchParams = new URLSearchParams(new FormData(this.form));
    if (!searchParams.get('q')?.trim()) return;

    SearchSortForm.updateResults(searchParams.toString());
  }

  static onPopState(event) {
    const searchParams = event.state?.searchParams ?? window.location.search.slice(1);
    if (searchParams === SearchSortForm.searchParamsPrev) return;
    SearchSortForm.updateResults(searchParams, false);
  }

  static updateResults(searchParams, updateHistory = true) {
    const parsed = new URLSearchParams(searchParams);
    if (!parsed.get('q')?.trim()) return;

    const sortForm = document.querySelector('search-sort-form');
    const sectionId = sortForm?.dataset.sectionId;
    if (!sectionId) return;

    const results = document.getElementById('SearchPageResults');

    SearchSortForm.searchParamsPrev = searchParams;
    results?.classList.add('is-loading');

    fetch(`${window.location.pathname}?section_id=${sectionId}&${searchParams}`)
      .then((response) => response.text())
      .then((html) => {
        const newResults = new DOMParser().parseFromString(html, 'text/html').getElementById('SearchPageResults');

        if (newResults && results) {
          results.innerHTML = newResults.innerHTML;
        }

        const sortBy = parsed.get('sort_by');
        const select = sortForm?.querySelector('select[name="sort_by"]');
        if (select && sortBy) select.value = sortBy;

        if (updateHistory) {
          history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
        }
      })
      .finally(() => {
        results?.classList.remove('is-loading');
        window.SearchPage?.syncProgress();
      });
  }
}

SearchSortForm.listenersReady = false;
SearchSortForm.searchParamsPrev = '';

customElements.define('search-sort-form', SearchSortForm);
